module.exports = __webpack_public_path__ + "img/logoHeader.6ac1c307.svg";